<template>
<b-modal
    :visible="isSectionModalActive"
    size="l"
    hide-footer
    no-close-on-backdrop
    @change="(val) => $emit('update:is-section-modal-active', val)"
    @shown="getData(sectionData)"
>
    <template #modal-title> Content Name </template>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
        >
            <b-form-group label-for="title">
                <b-tabs content-class="mt-1" v-if="langs.length > 0">
                    <b-tab
                        v-for="(lang, key) in langs"
                        :key="'tab-' + key"
                        :title="lang.name"
                    >
                        <validation-provider
                            #default="validationContext"
                            :name="'title_' + lang.code"
                            rules="min:0"
                        >
                            <b-form-group label="Title" :label-for="'title_' + lang.code">
                                <b-form-input
                                    :id="'title_' + lang.code"
                                    v-model="Data.title[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Title (' + lang.code + ')'"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-tab>
                </b-tabs>
            </b-form-group>
            <div class="d-flex mt-2">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                >
                    Submit
                </b-button>
                <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="button"
                    variant="outline-secondary"
                    @click="hide_form"
                >
                    Cancel
                </b-button>
            </div>
        </b-form>
    </validation-observer>
</b-modal>
</template>

<script>
import {
    BCard, BCardText, BFormFile, BForm, BFormGroup, BFormInput, BRow, BCol, BButton,
    BImg, BModal, BFormInvalidFeedback, BTabs, BTab,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { ref } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import axios from "@axios";
import "quill/dist/quill.snow.css";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  
export default {
    components: {
        BCard, BCardText, BFormFile, BTabs, BTab, BForm, BFormGroup, BFormInput, BRow, BCol,
        BButton, BImg, BFormInvalidFeedback, vSelect, BModal, ValidationProvider, ValidationObserver,
    },
    model: {
        prop: "isSectionModalActive",
        event: "update:is-section-modal-active",
    },
    props: {
        isSectionModalActive: {
            type: Boolean,
            required: true,
        },
        sectionData: {
            type: Object,
            required: false,
        },
    },
    directives: {
        Ripple,
    },
    setup(props, { emit }) {
        const toast = useToast();
        const tabIndex = ref(0);
        const langs = ref([]);
        const userStorage = JSON.parse(localStorage.getItem('userData'));
        const blankData = {
            id: "",
            title: {},
            guide_id: "",
            created_by: userStorage.id
        };
        const Data = ref(JSON.parse(JSON.stringify(blankData)));

        const getData = (data) => {
            if(data){
                Data.value = data;
            }
        };

        const resetData = () => {};

        const hide_form = () => {
            emit("update:is-section-modal-active", false);
        };

        const getLangs = (fil) => {
            store.dispatch("app-languages/fetchData", fil).then((res) => {
                if (res.data.success) {
                    langs.value = res.data.data;
                }
            });
        };

        let filter = {
            is_active: 1,
        };

        getLangs(filter);

        const onSubmit = async () => {
            if (Data.value.id) {
                let data = {
                    formData: formData,
                    id: Data.value.id,
                };
                const resp = await store.dispatch("guide-section/UpdateSection", data);
                if (resp.data.success) {
                    toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: `Success`,
                        icon: "BellIcon",
                        variant: "success",
                        text: `${resp.data.message}`,
                    },
                    });
                    emit("refesh-section", Data.value);
                } else {
                    toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: `Error`,
                        icon: "BellIcon",
                        variant: "danger",
                        text: `${resp.data.message}`,
                    },
                    });
                }
            } else {
                Data.value.created_by = userStorage.id

                const resp = await store.dispatch("guide-section/addContent", Data.value);
                if (resp.data.success) {
                    Data.value.id = resp.data.data;
                    toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                            title: `Success`,
                            icon: "BellIcon",
                            variant: "success",
                            text: `${resp.data.message}`,
                        },
                    });
                    emit("refesh-section", Data.value);
                } else {
                    toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: `Error`,
                        icon: "BellIcon",
                        variant: "danger",
                        text: `${resp.data.message}`,
                    },
                    });
                }
            }
  
            emit("update:is-section-modal-active", false);
        };
  
        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetData);

        return {
            getData,
            hide_form,
            Data,
            onSubmit,
            refFormObserver,
            getValidationState,
            resetForm,
            tabIndex,
            langs,
        };
    },
};
</script>
<style lang="scss">

@import "@core/scss/vue/libs/quill.scss";

</style>
  